/**
 * The species of a LitSquad item, by the one rule the avatar uses everywhere:
 * the server pipeline that checks an accessory fits its base and places it,
 * and the editor that offers accessories and previews the avatar. Kept here,
 * next to the geometry it selects, so the two can never disagree about which
 * accessories fit a character.
 */

/**
 * Lowercased species of a LitSquad item: its `Character` metadata key (set on
 * imported characters and on every accessory), else the species definition id
 * it was minted under (`litdef_species_<species>`). Null when neither resolves.
 */
export function litSquadItemSpecies(item: {
  itemDefId: string;
  metadata: Record<string, unknown> | null | undefined;
}): string | null {
  const character = item.metadata?.Character;
  if (typeof character === 'string' && character.trim()) return character.trim().toLowerCase();
  const match = item.itemDefId.match(/^litdef_species_([a-z]+)$/);
  return match ? match[1] : null;
}
